<template>
    <div style="padding: 10px">
        <div class="animated fadeIn">
            <b-row>
                <b-col sm="6" lg="2">
                    <b-card no-body class="bg-success">
                        <b-card-body class="pb-0">
                            <h4 class="mb-0">{{$money(totalStock)}}</h4>
                            <p>{{ $t("total_stock_amount") }}</p>
                        </b-card-body>
                    </b-card>
                </b-col>
                <b-col sm="6" lg="2">
                    <b-card no-body class="bg-warning">
                        <b-card-body class="pb-0">
                            <h4 class="mb-0">{{$money(totalSale)}}</h4>
                            <p>{{ $t("total_sale_amount") }}</p>
                        </b-card-body>
                    </b-card>
                </b-col>
                <b-col sm="6" lg="2">
                    <b-card no-body class="bg-danger">
                        <b-card-body class="pb-0">
                            <h4 class="mb-0">{{$money(totalReceipt)}}</h4>
                            <p>{{ $t("total_receipt_amount") }}</p>
                        </b-card-body>
                    </b-card>
                </b-col>
                <b-col sm="6" lg="2">
                    <b-card no-body class="bg-primary">
                        <b-card-body class="pb-0">
                            <h4 class="mb-0">{{$money(totalBill)}}</h4>
                            <p>{{ $t("total_expense_amount") }}</p>
                        </b-card-body>
                    </b-card>
                </b-col>
                <b-col sm="6" lg="2">
                    <b-card no-body class="bg-info">
                        <b-card-body class="pb-0">
                            <h4 class="mb-0">{{$money(totalOrder)}}</h4>
                            <p>{{ $t("total_order_amount") }}</p>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" lg="12">
                    <div class="x_body vld-parent" ref="load100">
                        <div class="card x_card">
                            <div class="card-header">
                                <i class="fa fa-bar-chart" aria-hidden="true"></i> {{$t("statistic_sale_per_months")}} {{$t('month_' + month)}}/{{year}}
                                <div class="pull-right">
                                    <select class="form-control form-control-sm" v-model="month">
                                        <option v-for="n in 12" :value="n" :key="n">{{$t('month_' + n)}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="card-body">
                                <SalePerMonthBarChart :month="month" />
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <br>
            <b-row>
                <b-col sm="6" lg="6">
                    <div class="x_body">
                        <div class="card x_card">
                            <div class="card-header">
                                <i class="fa fa-bar-chart" aria-hidden="true"></i> {{$t("statistic_sale_per_years")}} {{ year }}
                                <div class="pull-right">
                                    <select class="form-control form-control-sm" v-model="year">
                                        <option v-for="n in $years()" :value="n" :key="n">{{n}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="card-body">
                                <SalePerYearBarChart :year="year" />
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col sm="6" lg="6">
                    <div class="x_body">
                        <div class="card x_card">
                            <div class="card-header font-m">
                                <i class="fa fa-pie-chart" aria-hidden="true"></i> {{ $t("statistic_income_expense_chart") }}
                                <div class="pull-right">
                                    <select class="form-control form-control-sm" v-model="year">
                                        <option v-for="n in $years()" :value="n" :key="n">{{n}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="card-body">
                                <PieChart />
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import SalePerMonthBarChart from "./Chart/SalePerMonthBarChart";
import SalePerYearBarChart from "./Chart/SalePerYearBarChart";
import PieChart from "./Chart/PieChart";

export default {
    components: {
        SalePerMonthBarChart,
        SalePerYearBarChart,
        PieChart,
    },
    data: function () {
        return {
            totalStock: 0,
            totalSale: 0,
            totalReceipt: 0,
            totalBill: 0,
            totalOrder: 0,
            month: new Date().getMonth() + 1,
            year: new Date().getFullYear() 
        }
    },
    created(){
        this.getSummary();
    },
    methods: {
        getSummary(){
            var loading = this.$loading.show();
            this.$api().post('dashboard/summaries', { CompanyId: this.$store.state.company.Id }).then(res => {
                if(this.$isValid(res)){
                    this.totalStock = res.data.Json.TotalStock;
                    this.totalSale = res.data.Json.TotalSale;
                    this.totalReceipt = res.data.Json.TotalReceipt;
                    this.totalBill = res.data.Json.TotalExpense;
                    this.totalOrder = res.data.Json.TotalOrder;
                }
            }).finally(function(){ loading.hide(); });
        }
    }
};
</script>

<style>
    #card-chart-01,
    #card-chart-02 {
        width: 100% !important;
    }
    .card-header{
        border-bottom: 1px solid #ddd !important;
    }
</style>
